<div (click)="changeDirection()" class="orderableCell">
	<ng-content></ng-content>
	<i class="fa pull-right" [ngClass]="{'fa-sort': !direction, 'fa-sort-asc': direction == 'ASC', 'fa-sort-desc': direction == 'DESC'}" aria-hidden="true"></i>
</div>